import { AssetClass } from "types/AssetClass";
import { PrivateEquityCapitalCall } from "types/PrivateEquityCapitalCall";
import { createCustomAction } from "typesafe-actions";

const PRIVATEEQUITYCAPITALCALL_DATA_LOAD = "PRIVATEEQUITYCAPITALCALL/PRIVATEEQUITYCAPITALCALL_DATA_LOAD";
const PRIVATEEQUITYCAPITALCALL_DATA_LOAD_SUCCESS = "PRIVATEEQUITYCAPITALCALL/PRIVATEEQUITYCAPITALCALL_DATA_LOAD_SUCCESS";
const PRIVATEEQUITYCAPITALCALL_DATA_LOAD_FAIL = "PRIVATEEQUITYCAPITALCALL/PRIVATEEQUITYCAPITALCALL_DATA_LOAD_FAIL";

export type PrivateEquityCapitalCallContentType = "all" | keyof typeof AssetClass;

export const load = createCustomAction(
  PRIVATEEQUITYCAPITALCALL_DATA_LOAD,
  (type) => (contentType: PrivateEquityCapitalCallContentType) => ({
    type,
    contentType,
  })
);

export const loadSuccess = createCustomAction(
  PRIVATEEQUITYCAPITALCALL_DATA_LOAD_SUCCESS,
  (type) => (contentType: PrivateEquityCapitalCallContentType,
             data?: PrivateEquityCapitalCall[]) => ({
    type,
    contentType,
    data,
  })
);

export const loadFail = createCustomAction(
  PRIVATEEQUITYCAPITALCALL_DATA_LOAD_FAIL,
  (type) => (contentType: PrivateEquityCapitalCallContentType, error?: string) => ({
    type,
    contentType,
    error,
  })
);
